<template>
  <div class="Toplist">
    <div class="serach-box">
      <!-- 顶部导航栏 -->
      <div class="header">
        <el-row type="flex" justify="center" style="height:100%;">
          <el-col :span="8" class="row_logo row" >
            <a href style="text-align: center;">
              <img class="header_logo" src="static/img/logo2022.png" />
            </a>
          </el-col>
          <el-col :span="10">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="6" class="row">
            <div v-if="!user">
              <span @click="login()">登录</span>
              <span>/</span>
              <span @click="reg()">注册</span>
            </div>
            <div v-else>
              <span @click="center">{{user.Name}} 个人中心</span>
              <span @click="logout()">/退出</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 中间搜索模块 -->
      <div class="box_body">
        <div class="serach">
          <div class="tit">
            <span>统一检索入口，支持检索专家、机构、研究领域</span>
          </div>
          <el-input
            v-model="input"
            :placeholder="defaultVal"
            style="width:100%;"
            @keyup.enter.native="search(input)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search(input)"
              :loading="loading5"
            ></el-button>
          </el-input>
        </div>
        <div class="title" v-loading="loading2">
          <div v-for="item in titleList" @click="goState" :key="item.value" class="title-for">
            <img :src="item.images" />
            <div class="title-right">
              <div style="color:#66776d">{{item.num}}</div>
              <div style="font-size:.7em;" class="title_tit">
                <span>{{item.value}}</span>
                <span
                  style="font-size:.7em;word-break: break-all;word-break: break-word;"
                >{{item.english}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img :src="avatar" alt="" srcset=""> -->
    <!-- 页面中间部分 -->
    <div class="top-box">
      <!-- 左侧 -->
      <div class="top-left" v-loading="loading1">
        <div v-for="(item,index) in topList" :key="index" class="top-list">
          <div class="top-lable">
            <img :src="item.images" />
            <div style="margin-left:5px;" v-if="!index">“{{keyword}}”领域TOP专家</div>
            <div style="margin-left:5px;" v-else>“{{keyword}}”领域TOP{{index === 1 ? '研究机构' :'期刊'}}</div>
          </div>
          <div v-for="(temp,ins) in item.list" :key="ins" class="top" @click="goto(index,ins)">
            <el-popover
              placement="right-start"
              :trigger="index === 2 ? 'manual' : 'hover'"
              class="card"
              @show="getData(index, ins)"
            >
              <div v-if="!index" @click="goExp(temp.kId)" v-loading="loading3">
                <el-row style="width:30em" :gutter="20">
                  <el-col :span="8" style="height:10em;display:flex;">
                    <img
                      width="100%"
                      v-if="expert[ins].avatarUrl"
                      :src="expert[ins].avatar || '/old/public'+expert[ins].avatarUrl"
                    />
                    <!-- || '/old/public'+expert[ins].avatarUrl -->
                    <img
                      width="100%"
                      v-else
                      src="http://expert.ckcest.cn/autoload/images/avatar.png"
                    />
                  </el-col>
                  <el-col
                    :span="16"
                    style="display: flex;flex-direction: column;justify-content: space-between;height: 10em;"
                  >
                    <div>{{expert[ins].name}}</div>
                    <div
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap; width: 18em;"
                    >{{expert[ins].organization}}</div>
                    <div>
                      <i class="el-icon-circle-check" /> 已认领
                    </div>
                    <div v-if="expert[ins].isni">ISNI {{expert[ins].isni}}</div>
                    <div
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap; width: 18em;"
                      :title="expert[ins].subject"
                    >学科 {{expert[ins].subject}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" style="margin:30px 0;" v-if="expert[ins].keyword">
                    <span
                      v-for="tabindex in 4"
                      :key="tabindex"
                      style="background: #76877d;margin-right: 1em;padding: 10px;border-radius: 10px;color: white"
                    >{{expert[ins].keyword[tabindex]}}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" style="display:flex;flex-direction:row;">
                    <div
                      v-for="items in expert[ins].resource"
                      :key="items.value"
                      style="display:flex;flex-direction:row;margin-right: 1em;"
                    >
                      <img src="static/img/icon/papers.png" v-if="items.name === '期刊论文'" />
                      <img src="static/img/icon/project.png" v-if="items.name === '项目成果'" />
                      <img src="static/img/icon/patent.png" v-if="items.name === '专利'" />
                      <div style="margin-left:1em;">
                        <span>{{items.count}}</span>
                        <p>{{items.name}}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-if="index === 1" style="width:400px" v-loading="loading3">
                <el-row>
                  <el-col :span="6" :offset="1" style="height:4.5em;display:flex">
                    <img
                      style="width:80px;height:80px"
                      v-if="showImg && org[ins].logo"
                      :ref="'orgLogo'+ins"
                      :src="org[ins].logo"
                      @error="imgError(ins)"
                    />
                  </el-col>
                  <el-col
                    :span="16"
                    :gutter="40"
                    :offset="1"
                    style="height:4.5em;display:flex;align-items:center"
                  >
                    <span style="font-size:1.5em;font-weight:700">{{temp.key}}</span>
                  </el-col>
                </el-row>
                <el-row style="padding:50px 0;border-bottom: 3px solid #76877d;display:flex">
                  <el-col :span="24" :offset="1" style="display:flex">
                    <div
                      :title="org[ins].introduction"
                      v-if="org[ins].introduction"
                    >{{org[ins].introduction.slice(0,100)+'...'}}</div>
                    <div v-else style="margin:auto">暂无简介</div>
                  </el-col>
                </el-row>
                <el-row style="margin:20px 0 0 20px">
                  <el-col :span="16" style="display:flex;flex-direction:row;margin-right: 1em;">
                    <img src="static/img/icon/user.png" style="height:40px;" />
                    <div style="margin-left:1em;">
                      <span>{{org[ins].topCreators}}</span>
                      <p>专家数量</p>
                    </div>
                    <img src="static/img/icon/papers.png" style="margin-left:20px;height:40px;" />
                    <div style="margin-left:1em;">
                      <span>{{org[ins].ResourcesCount}}</span>
                      <p>论文</p>
                    </div>
                  </el-col>

                  <el-col :span="4">
                    <el-button
                      v-if="org[ins].name"
                      style="background:#76877d;color:#ffffff;"
                      round
                      @click="goOrg(org[ins].name)"
                    >查看详情</el-button>
                  </el-col>
                </el-row>
              </div>
              <div
                slot="reference"
                style="width:70%;cursor:pointer"
                v-if="ins < 15"
              >{{ins+1}}. {{temp.key}}</div>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="top-right">
        <label style="font-size:17px;">高级检索</label>
        <div class="mgTop-20">系统对于多条件查询的推荐检索方式结构如下:</div>
        <div>
          <el-input
            v-model="expertsValue"
            :placeholder="expertsPlace"
            style="width:90%;"
            class="mgTop-20"
          >
            <i
              slot="suffix"
              class="el-input__icon"
              :class="loading5 ? 'el-icon-loading':'el-icon-search'"
              @click="expertSearch(expertsValue)"
            ></i>
          </el-input>
        </div>
        <div class="mgTop-20">
          {{expertsValue?expertsValue.trim().split(/\s+/)[0]:expertsPlace.trim().split(/\s+/)[0]}} 机构为
          {{expertsValue?expertsValue.trim().split(/\s+/)[1]:expertsPlace.trim().split(/\s+/)[1]}}
        </div>
        <div>
          <el-input
            v-model="fieldValue"
            :placeholder="fieldPlace"
            style="width:90%;"
            class="mgTop-20"
          >
            <i
              slot="suffix"
              class="el-input__icon"
              :class="loading5 ? 'el-icon-loading':'el-icon-search'"
              @click="fieldSearch(fieldValue)"
            ></i>
          </el-input>
        </div>

        <div class="mgTop-20" style="padding-bottom:2.5em">
          查询关键词
          {{fieldValue||fieldPlace}} 方向的专家、成果、机构。
        </div>

        <label style="font-size:17px;">分类检索</label>
        <div class="mgTop-20">分类检索：可通过检索机构、学术期刊及关键词，去发现有价值的学术信息。</div>
        <div class="retrieve">
          <img class="img" src="static/img/icon/university.png" />
          <div style="width:100%;">
            <div>
              <el-input
                v-model="orgValue"
                :placeholder="orgPlace"
                style="width:90%;"
                class="mgTop-20"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="orgSearch(orgValue)"></i>
              </el-input>
            </div>
            <div class="mgTop-20">
              检索机构，查询
              {{orgValue||orgPlace}}的学术研究概况。
            </div>
          </div>
        </div>
        <div class="retrieve">
          <img class="img" src="static/img/icon/page.png" />
          <div style="width:100%;">
            <div>
              <el-input
                v-model="journalValue"
                :placeholder="journalPlace"
                style="width:90%;"
                class="mgTop-20"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="journalSearch(journalValue)"
                ></i>
              </el-input>
            </div>
            <div class="mgTop-20">
              检索期刊，查询
              {{journalValue || journalPlace}}发文的数据概况。
            </div>
          </div>
        </div>
        <div class="retrieve" style="padding-bottom:2.5em">
          <img class="img" src="static/img/icon/compass.png" />
          <div style="width:100%;">
            <div>
              <el-input
                v-model="keywordValue"
                :placeholder="keywordPlace"
                style="width:90%;"
                class="mgTop-20"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="keywordSearch(keywordValue)"
                ></i>
              </el-input>
            </div>
            <div class="mgTop-20">
              检索关键词，查询
              {{keywordValue||keywordPlace}}相关研究的数据概况及研究趋势。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 页面底部部分 -->
    <div class="home-news">
      <div class="news-left">
        <div class="home-report lable">
          <div class="home-report-lable header-lable">
            <h3>精品报告</h3>
          </div>
          <div class="home-report-body">
            <a
              class="report-list"
              v-for="(item,index) in reportList"
              :key="index"
              :href="item.url"
              target="_blank"
            >
              <img :src="item.src" alt />
              <div>{{item.title}}</div>
              <div>{{item.subtitle}}</div>
            </a>
          </div>
        </div>
      </div>
      <div class="news-right news-left">
        <div class="home-blog lable">
          <div class="home-blog-lable header-lable">
            <h3>专题分析</h3>
          </div>
          <div class="home-blog-body">
            <div
              class="blog-list"
              v-for="item in blogList"
              :key="item.value"
              @click="goroad(item.value)"
            >
              <img :src="item.images" alt />
              <div>{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCountdata,
  getRec,
  getRecExpert,
  getOrg,
  getDefaultKeywords
} from "@/api/home";
import { getBase64Avatar } from "@/api/center";
import { login, exit, reg } from "@/utils/index";
import $ from "jquery";
export default {
  name: "Toplist",
  data() {
    return {
      input: "", // 搜索值
      defaultVal: "", // 默认搜索值
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : "", // 用户信息
      titleList: [
        {
          value: "专家数量/",
          english: "Experts",
          images: "static/img/icon/user.png",
          num: "0",
          code: "N"
        },
        {
          value: "中文论文/",
          english: "Papers",
          images: "static/img/icon/papers.png",
          num: "0",
          code: "J"
        },
        {
          value: "专利/",
          english: "Patents",
          images: "static/img/icon/patent.png",
          num: "0",
          code: "P"
        },
        {
          value: "图书/",
          english: "Books",
          images: "static/img/icon/books.png",
          num: "0",
          code: "B"
        },
        {
          value: "科学引文索引/",
          english: "Sci",
          images: "static/img/icon/sci.png",
          num: "0",
          code: "I"
        },
        {
          value: "工程索引/",
          english: "Ei",
          images: "static/img/icon/EI.png",
          num: "0",
          code: "E"
        },
        {
          value: "成果奖励/",
          english: "Achievements",
          num: "0",
          images: "static/img/icon/reward.png",
          code: "A"
        },
        {
          value: "项目/",
          english: "Projects",
          images: "static/img/icon/project.png",
          num: "0",
          code: "O"
        }
      ], // 顶部搜索框右侧数据
      topList: [
        {
          images: "static/img/icon/user.png",
          list: []
        },
        {
          images: "static/img/icon/university.png",
          list: []
        },
        {
          images: "static/img/icon/book.png",
          list: []
        }
      ], // TOP领域数组数据
      keyword: "", // TOP领域
      blogList: [
        {
          images: "static/img/home/blog2.jpg",
          title: "基于病毒学的情报分析数据集",
          value: 3
        },
        {
          images: "static/img/home/blog3.jpg",
          title: "基于病毒学文献数据集的情报分析",
          value: 4
        },
        {
          images: "static/img/home/blog4.jpg",
          title: "全球智库影响力评价研究",
          value: 1
        },
        {
          images: "static/img/home/blog1.jpg",
          title: "人工智能评价研究",
          value: 2
        }
      ], // 专题分析数组

      /* 高级检索参数 */
      expertsPlace: "浙江大学 孙优贤",
      expertsValue: "",
      fieldPlace: "冠状病毒",
      fieldValue: "",
      orgPlace: "清华大学",
      orgValue: "",
      journalPlace: "计算机学报",
      journalValue: "",
      keywordPlace: "神经网络",
      keywordValue: "",

      /* loading */
      loading1: false,
      loading2: false,
      loading3: false,
      loading5: false,
      avatar: "",
      expert: [], // top领域专家信息
      org: [], // top领域机构信息
      showImg: true, // 是否显示图片
      reportList: [
        {
          src: "static/img/home/rep4.png",
          url: "http://expert.ckcest.cn/pdf/2019评价报告.pdf",
          title: "全球智库影响力评价报告",
          subtitle: "(2019)"
        },
        {
          src: "static/img/home/rep3.png",
          url: "https://ciraa.zju.edu.cn/report/report20200323.pdf",
          title: "人工智能发展水平评价分析报告",
          subtitle: "(2019)"
        },

        {
          src: "static/img/home/rep1.png",
          url: "http://expert.ckcest.cn/pdf/影响力报告.pdf",
          title: "全球智库影响力评价报告",
          subtitle: "(2018)"
        },
        {
          src: "static/img/home/rep2.png",
          url: "http://expert.ckcest.cn/pdf/2018评价报告.pdf",
          title: "人工智能发展水平评价分析报告",
          subtitle: "(2018)"
        }
      ] // 精品报告数组
    };
  },
  methods: {
    // 领域top跳转
    goto(index, ins) {
      const that = this;
      let routeData;
      if (!index) {
        routeData = this.$router.resolve({
          name: "Detail",
          query: {
            kId: that.topList[index].list[ins].kId,
            keyword: this.keyword
          }
        });
      } else if (index === 1) {
        routeData = this.$router.resolve({
          name: "Overview",
          query: { organization: that.topList[index].list[ins].key }
        });
      } else {
        routeData = this.$router.resolve({
          path: "Periodical",
          query: { keyword: that.topList[index].list[ins].key }
        });
      }
      window.open(routeData.href, "_blank");
    },
    // 搜索
    search(val) {
      // if (!this.defaultKid) {
      //   this.$message({
      //     message: '请输入搜索内容',
      //     type: 'warning'
      //   })
      //   this.$router.push({ name: 'Detail', query: { kId: this.defaultKid } })
      //   return
      // }
      let data = val;
      if (!data) {
        getDefaultKeywords({}).then(res => {
          //搜索关键字拼随机
          var randomIndex = Math.round(Math.random() * res.data.length);
          data = res.data[randomIndex];
          localStorage.setItem("val", data);
          localStorage.setItem("highVal", data);
          this.$store.commit("setSearchTxt", data);
          this.$router.push({ name: "Loading", params: { data } });
        });
        return;
      }
      if (val.length === 1) {
        this.$message("请输入更多的关键词");
        return;
      }
      localStorage.setItem("val", val);
      localStorage.setItem("highVal", data);
      this.$router.push({ name: "Loading", params: { data: data } });
    },
    // 机构图片加载失败的时
    imgError(index) {
      this.showImg = false;
      this.org[index].logo = "";
      this.showImg = true;
    },
    // 登录
    login() {
      login();
    },
    // 注册
    reg() {
      reg();
    },
    // 退出
    logout() {
      exit();
      this.$message("退出成功");
      this.user = "";
    },
    // 跳转到个人中心
    center() {
      this.$router.push({ name: "center" });
    },

    /* 高级检索搜索 */
    expertSearch(val) {
      let data = val || this.expertsPlace;
      localStorage.setItem("val", data);
      localStorage.setItem("highVal", data);
      this.$router.push({ name: "Loading", params: { data: data } });
    },
    fieldSearch(val) {
      let data = val || this.fieldPlace;
      localStorage.setItem("val", data);
      localStorage.setItem("highVal", data);
      this.$router.push({ name: "Loading", params: { data: data } });
    },
    orgSearch(val) {
      let name = val || this.orgPlace;
      let routeData = this.$router.resolve({
        name: "Overview",
        query: { organization: name }
      });
      window.open(routeData.href, "_blank");
    },
    journalSearch(val) {
      let data = val || this.journalPlace;
      let routeData = this.$router.resolve({
        name: "Periodical",
        query: { keyword: data }
      });
      window.open(routeData.href, "_blank");
    },
    keywordSearch(val) {
      let data = val || this.keywordPlace;
      let routeData = this.$router.resolve({
        name: "Keyword",
        query: { keyword: data }
      });
      window.open(routeData.href, "_blank");
    },

    // 获取
    getData(index, ins) {
      this.showImg = true;
      if (!index) {
        this.loading3 = true;
        this.getRecExpert(this.topList[0].list[ins].kId, ins);
      }
    },
    getBase64Avatar(kId, index) {
      var that = this;
      return new Promise((resolve, reject) => {
        getBase64Avatar({ kId: kId }).then(res => {
          resolve(
            res.data[0].data[0] && res.data[0].data[0].avatar
              ? res.data[0].data[0].avatar.replace(/[\r\n]/g, "")
              : ""
          );
        });
      });
    },
    // 获取专家信息
    async getRecExpert(kId, index) {
      let data = {
        kId: kId
      };
      var avatar = "";
      if (!isNaN(kId)) {
        await this.getBase64Avatar(kId, index).then(res => {
          avatar = res;
        });
      }
      getRecExpert(data)
        .then(res => {
          res.data[0].avatar = avatar;
          this.expert[index] = res.data[0];
          this.expert[index].keyword = this.expert[index].keyword.split(";");
          this.expert[index].resource = res.resource;
          this.loading3 = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取学校信息
    getOrg(name, index) {
      let data = {
        name: name,
        type: ""
      };
      getOrg(data)
        .then(res => {
          let count = 0;
          res.data.stat.topResources.forEach((item, index) => {
            count = count + item.doc_count;
          });
          if (Object.keys(res.data.data.result).length) {
            this.org[index] = res.data.data.result[0];
          }
          this.org[index].topCreators = res.data.stat.topCreators;
          this.org[index].ResourcesCount = count;
          this.$nextTick(() => {
            if (index === this.topList[1].list.length - 1) {
              this.loading3 = false;
              console.log(this.org);
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    goState() {
      //跳转到数据说明首页
      let routeData = this.$router.resolve({
        name: "state"
      });
      window.open(routeData.href, "_blank");
    },
    // 跳转到专家
    goExp(kId) {
      this.$router.push({
        path: "/Detail",
        query: { kId: kId, keyword: this.keyword }
      });
    },
    // 跳转到学校
    goOrg(name) {
      let routeData = this.$router.resolve({
        name: "Overview",
        query: { organization: name }
      });
      window.open(routeData.href, "_blank");
    },
    // 专题分析跳转
    goroad(index) {
      let routeData = "";
      if (index === 1) {
        routeData = this.$router.resolve({
          path: "/thinkTank"
        });
        //   window.open(routeData.href, '_blank')
        // } else
      } else if (index === 2) {
        routeData = this.$router.resolve({
          path: "/Ai"
        });
      } else if (index === 3) {
        routeData = this.$router.resolve({
          path: "/blog1"
        });
      } else {
        routeData = this.$router.resolve({
          path: "/blog2"
        });
      }
      window.open(routeData.href, "_blank");
    }
  },
  mounted() {
    this.loading1 = true;
    this.loading2 = true;
    let k = this.$route.query.k;
    if (k) {
      this.search(k);
    }
    // 获取领域TOP数据
    getRec()
      .then(res => {
        this.loading1 = false;
        res.data.expert.slice(0, 10).forEach((item, index) => {
          if (Object.keys(item).length === 3) {
            let temp = {
              key: item.name,
              kId: item.key,
              doc_count: item.doc_count
            };
            let data = {
              avatarUrl: "http://expert.ckcest.cn/autoload/images/avatar.png",
              name: "",
              organization: "",
              isni: "",
              subject: "",
              resource: "",
              keyword: ""
            };
            this.expert.push(data);
            this.topList[0].list.push(temp);
          }
        });
        this.keyword = res.data.keyword;
        this.topList[1].list = res.data.organization.slice(0, 10);
        this.org = this.topList[1].list.map(it => {
          return {
            logo: "",
            key: "",
            introduction: "",
            ResourcesCount: "",
            topCreators: ""
          };
        });
        this.loading3 = true;
        this.$nextTick(() => {
          this.topList[1].list.forEach((item, index) => {
            this.getOrg(item.key, index);
          });
        });
        this.topList[2].list = res.data.journal.slice(0, 10);
      })
      .catch(err => {
        console.log(err);
      });
    // 获取收录论文数量
    getCountdata()
      .then(res => {
        this.loading2 = false;
        this.titleList[0].num = parseFloat(
          res.expert_total_count.data[0]
        ).toLocaleString();
        this.titleList.forEach((item, index) => {
          if (!index) {
            return true;
          }
          res.allcount.data.forEach((temp, val) => {
            if (temp.key === item.code) {
              this.titleList[index].num = parseFloat(
                temp.doc_count
              ).toLocaleString();
            }
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
    let that = this;
    // 搜索栏默认值
    // $.ajax({
    //   data: {},
    //   dataType: 'json',
    //   success: function (res) {
    //     var randomIndex = Math.round(Math.random() * res.data.length)
    //     if (!this.input) {
    //       that.defaultKid = res.data[randomIndex].kId
    //       that.defaultVal =
    //         res.data[randomIndex].name +
    //         ' ' +
    //         res.data[randomIndex].organization
    //     }
    //   }
    // })
  },
  components: {}
};
</script>

<style lang="scss">
.Toplist {
  min-width: 1296px;
  font-size: 0.85em;
  .survey {
    position: fixed;
    left: 20px;
    bottom: 20px;
    z-index: 9999;
    cursor: pointer;
    img {
      z-index: 10000;
    }
    .survey-close {
      position: absolute;
      top: -5px;
      right: 4px;
      z-index: 19999;
    }
  }
  .serach-box {
    background: url(../../static/img/home/home_bg.png) no-repeat;
    background-size: cover !important;
    background-position: center;
    height: 36em;
    width: 100%;
    .header {
      background: url(../../static/img/home/bg-z.png);
      height: 80px;
      border-bottom: 1px solid white;
      .row_logo {
        // background: url(../../static/img/home/bg-z.png) repeat-x !important;
        border-right: 2px solid white;
        .header_logo {
          height: 50px;
        }
      }
      .grid-content {
        border-radius: 4px;
        min-height: 36px;
      }
      .row {
        font-family: "黑体";
        font-size: 1.5em;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        div {
          cursor: pointer;
        }
      }
    }
    .box_body {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .serach {
        margin-left: 10%;
        margin-top: 6%;
        align-items: center;
        width: 50%;
        height: 110px;
        .el-input {
          .el-input__inner {
            font-size: 1.5em;
            line-height: 1.5em;
            padding: 1.5em;
          }
        }
        .el-input-group__append {
          border: none;
          background: #93a199;
          color: white;
          font-size: 1.5em;
          width: 3.5em;
          .el-button {
            width: 3.5em;
          }
        }
        .tit {
          font-size: 2em;
          line-height: 1em;
          padding-bottom: 1em;
          color: white;
          span {
            margin-right: 20px;
          }
        }
      }
      .title {
        width: 20em;
        background: white;
        margin-right: 5em;
        z-index: 100;
        box-shadow: 10px 10px 5px #888888;
        margin-top: 1.5em !important;
        .title-for {
          font-size: 1.5em;
          display: flex;
          flex-direction: row;
          margin: 0.5em 1em;
          padding-top: 0.5em;
          cursor: pointer;
          img {
            margin-top: 0.5em;
            width: 1.3em;
            height: 1.3em;
          }
          .title-right {
            margin-left: 0.7em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .title_tit {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: center;
            }
          }
        }
        .title-for + .title-for {
          border-top: 1px solid #cfcfcf;
        }
      }
    }
  }
  .top-box {
    min-width: 1200px;
    background: #f2f2f2;
    margin: 0 auto;
    padding: 40px 4% !important;
    display: flex;
    flex-direction: row;
    .top-left {
      background: white;
      width: 49%;
      margin-right: 2%;
      border-top: 5px solid #606060;
      padding-top: 15px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .top-list {
        width: 46%;
        border-bottom: 1px solid #cfcfcf;
        margin: 0 2%;
        .top-lable {
          display: flex;
          flex-direction: row;
          margin: 10px 0;
          img {
            width: 1em;
            height: 1em;
          }
        }
        .top {
          margin: 20px 0;
        }
        .top :hover {
          color: red;
        }
        .foot-list {
          margin: 30px 0;
          font-weight: 700;
        }
      }
    }
    .top-right {
      width: 49%;
      background: white;
      font-size: 12px;
      padding: 20px;
      .retrieve {
        display: flex;
        flex-direction: row;
        width: 100%;
        .img {
          margin-top: 2.5em;
          width: 3em;
          height: 3em;
          margin-right: 1.5em;
        }
      }
      .mgTop-20 {
        margin-top: 2.5em;
        .el-input__inner {
          cursor: pointer;
        }
        img {
          margin: 0 5px;
          width: 1.5em;
        }
      }
    }
  }
  .home-news {
    min-width: 1200px;
    background: #f2f2f2;
    margin: 0 auto;
    padding: 0 4% !important;
    display: flex;
    flex-direction: row;
    .lable {
      width: 100%;
      margin-top: 20px;
      .header-lable {
        h3 {
          font-size: 17px;
          font-weight: 700;
          text-align: center;
        }
      }
    }
    .news-left {
      background: white;
      width: 49%;
      margin-right: 2%;
      margin-bottom: 40px;
      padding-top: 15px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .home-report {
        .home-report-body {
          display: flex;
          flex-direction: row;
          padding: 0 10px;
          justify-content: space-between;
          .report-list {
            cursor: pointer;
            width: 23%;
            margin-top: 10px;
            text-align: center;

            img {
              margin-top: 5px;
              max-width: 100%;
            }
          }
        }
      }
      .home-blog {
        margin-bottom: 20px;
        .home-blog-body {
          padding: 0 10px;
          display: flex;
          flex-direction: row;
          flex-flow: wrap;
          margin-top: 10px;
          justify-content: space-between;
          .blog-list {
            cursor: pointer;
            text-align: center;
            width: 23%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .news-right {
      margin-bottom: 40px;
      width: 49%;
      background: white;
      font-size: 12px;
      padding: 20px 10px;
      .home-technology {
        .home-technology-body {
          display: flex;
          flex-direction: row;
          .home-technology-body-left {
            display: flex;
            flex-direction: column;
            .technology-list {
              border-bottom: 1px dashed #e4e4e4;
              padding-bottom: 20px;
              margin-top: 20px;
              .technology-header {
                display: flex;
                justify-content: space-between;
                font-size: 18px;
                color: #333;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                a:hover {
                  color: #00a0e9;
                }
                .el-tag {
                  background-color: #fff;
                  border: 1px solid #00a0e9;
                  color: #00a0e9;
                }
                .el-tag:hover {
                  cursor: pointer;
                  background-color: #00a0e9;
                  color: #fff;
                }
              }
              p {
                color: #666;
                margin: 20px 0;
              }
              .technology-footer {
                display: flex;
                div {
                  padding: 2px 4px;
                  margin-right: 10px;
                  color: #999;
                }
              }
            }
          }
          .home-technology-body-right {
            h3 {
              margin: 20px 0;
            }
            .el-tag {
              margin: 5px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue